import PersonalIdentityInfo from "./PersonalIdentityInfo";

export default PersonalIdentityInfo;
